
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Creates a test suggestion in Supabase for debugging purposes
 * @returns Promise that resolves when the operation is complete
 */
export const createTestSuggestion = async (): Promise<void> => {
  try {
    console.log('Creating test suggestion...');
    
    const { data, error } = await supabase.functions.invoke('send-suggestion', {
      body: { 
        message: "Dette er en test melding for debugging",
        senderEmail: "test@example.com",
        senderName: "Test Bruker"
      }
    });
    
    if (error) {
      console.error('Error creating test suggestion:', error);
      toast.error('Kunne ikke opprette test forslag');
      return;
    }
    
    console.log('Test suggestion created:', data);
    toast.success('Test forslag opprettet');
  } catch (error) {
    console.error('Error in createTestSuggestion:', error);
    toast.error('Kunne ikke opprette test forslag');
  }
};

/**
 * Directly inserts a suggestion into the Supabase database for debugging
 * @returns Promise that resolves when the operation is complete
 */
export const createDirectSuggestion = async (): Promise<void> => {
  try {
    console.log('Creating direct test suggestion...');
    
    const { data, error } = await supabase
      .from('suggestions')
      .insert([
        { 
          message: "Dette er en direkte test melding for debugging",
          sender_email: "direct-test@example.com",
          sender_name: "Direkte Test"
        }
      ])
      .select();
    
    if (error) {
      console.error('Error creating direct test suggestion:', error);
      toast.error('Kunne ikke opprette direkte test forslag');
      return;
    }
    
    console.log('Direct test suggestion created:', data);
    toast.success('Direkte test forslag opprettet');
  } catch (error) {
    console.error('Error in createDirectSuggestion:', error);
    toast.error('Kunne ikke opprette direkte test forslag');
  }
};
